import React from "react";
import "./MergeExerciseModal.css";
import imagee from "../../../images/placeholder.png";

const MergeExerciseModal = ({
  merge,
  setMerge,
  removeMerge,
  setRemoveMerge,
  mvideo,
  setMvideo,
  mergeexercises,
  apiexercises,
  workoutData,
  formateSetsinputs,
  selectedExerciseIds,
  selectedExerciseremoveIds,
  handleExerciseClickk,
  handleExerciseClickRemove,
  mergeId,
  mergeExercisesNow,
  removeMergeNow,
  mergePayLoad,
  removePayLoad,
}) => {
  const formatFieldValue = (fieldName, values) => {
    const units = {
      WEIGHT: "kgs",
      Distance: "meters",
      CALORIES: "calories", 
      DURATION: "minutes",
      REPETITIONS: "reps",
      DISTANCE: "meters",
      "Jump Row": "meters"
    };
    
    return {
      label: fieldName,
      value: values.join("/"),
      unit: units[fieldName] || ""
    };
  };

  const renderExerciseItem = (item, exc, isSelected, onClick) => (
    <div
      key={item.id}
      className={`pw_exercise-item ${isSelected ? "pw_selected" : ""}`}
      onClick={() => onClick(exc?.workout_exercise_id)}
    >
      <img 
        src={imagee} 
        alt="Exercise" 
        className="pw_exercise-image"
      />
      
      <div className="pw_exercise-info">
        <h4 className="pw_exercise-name">{item?.name}</h4>
        
        <div className="pw_exercise-details">
          <div className="pw_exercise-sets">
            Sets: {workoutData?.workout_type === "AMRAP" ? (
              <span>Max</span>
            ) : (
              <span>{item?.sets?.length}</span>
            )}
          </div>
          
          <div className="pw_exercise-meta">
            {Object.entries(formateSetsinputs(item?.sets)).map(([fieldName, values]) => {
              const formatted = formatFieldValue(fieldName, values);
              return (
                <div key={fieldName} className="pw_exercise-meta-item">
                  <span className="pw_exercise-meta-label">{formatted.label}:</span>
                  <span className="pw_exercise-meta-value">{formatted.value}</span>
                  {formatted.unit && (
                    <span className="pw_exercise-meta-unit">{formatted.unit}</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );

  if (merge) {
    const availableExercises = mergeexercises
      ?.filter(mergedexercise => mergedexercise?.workout_exercises?.length < 2)
      ?.flatMap(mergedexercise => 
        mergedexercise?.workout_exercises?.map(exc => {
          const exercise = apiexercises?.find(item => item.id == exc?.workout_exercise_id);
          return exercise ? { exercise, exc } : null;
        }).filter(Boolean)
      ) || [];

    return (
      <div className="pw_merge-modal-overlay">
        <div className="pw_merge-modal">
          <div className="pw_merge-modal-header">
            <h2 className="pw_merge-modal-title">
              <i className="fa fa-link"></i>
              Merge Exercises
            </h2>
            <button 
              className="pw_merge-modal-close"
              onClick={() => setMerge(false)}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          <div className="pw_merge-modal-content">
            <div className="pw_video-input-section">
              <label className="pw_video-input-label">
                Complex/Merger Video Link
              </label>
              <input
                type="text"
                className="pw_video-input"
                placeholder="Enter video URL for the merged exercise complex"
                value={mvideo}
                onChange={(e) => setMvideo(e.target.value)}
              />
            </div>

            <div className="pw_exercises-section">
              {availableExercises.length > 0 ? (
                <div className="pw_exercises-list">
                  {availableExercises.map(({ exercise, exc }) => 
                    renderExerciseItem(
                      exercise,
                      exc,
                      selectedExerciseIds?.some(item => 
                        item.workout_exercise_id === exc?.workout_exercise_id
                      ),
                      handleExerciseClickk
                    )
                  )}
                </div>
              ) : (
                <div className="pw_empty-exercises">
                  <div className="pw_empty-exercises-icon">
                    <i className="fa fa-dumbbell"></i>
                  </div>
                  <h3>No Exercises Available</h3>
                  <p>There are no exercises available for merging at this time.</p>
                </div>
              )}
            </div>
          </div>

          <div className="pw_merge-modal-actions">
            <button
              className="pw_merge-action-btn"
              onClick={() => mergeExercisesNow(mergePayLoad)}
              disabled={!selectedExerciseIds?.length}
            >
              <i className="fa fa-link"></i>
              Merge Exercises Now
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (removeMerge) {
    const mergedExercise = mergeexercises?.find(mergedexercise => mergedexercise?.id == mergeId);
    const exercisesToRemove = mergedExercise?.workout_exercises
      ?.filter(() => mergedExercise?.workout_exercises?.length > 1)
      ?.map(exc => {
        const exercise = apiexercises?.find(item => item.id == exc?.workout_exercise_id);
        return exercise ? { exercise, exc } : null;
      }).filter(Boolean) || [];

    return (
      <div className="pw_merge-modal-overlay">
        <div className="pw_merge-modal">
          <div className="pw_merge-modal-header">
            <h2 className="pw_merge-modal-title">
              <i className="fa fa-unlink"></i>
              Remove from Merge
            </h2>
            <button 
              className="pw_merge-modal-close"
              onClick={() => setRemoveMerge(false)}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>

          <div className="pw_merge-modal-content">
            <div className="pw_exercises-section">
              {exercisesToRemove.length > 0 ? (
                <div className="pw_exercises-list">
                  {exercisesToRemove.map(({ exercise, exc }) => 
                    renderExerciseItem(
                      exercise,
                      exc,
                      selectedExerciseremoveIds?.some(item => 
                        item.workout_exercise_id === exc?.workout_exercise_id
                      ),
                      handleExerciseClickRemove
                    )
                  )}
                </div>
              ) : (
                <div className="pw_empty-exercises">
                  <div className="pw_empty-exercises-icon">
                    <i className="fa fa-unlink"></i>
                  </div>
                  <h3>No Exercises to Remove</h3>
                  <p>This merge doesn't have enough exercises to remove any.</p>
                </div>
              )}
            </div>
          </div>

          {selectedExerciseremoveIds?.length > 0 && (
            <div className="pw_merge-modal-actions">
              <button
                className="pw_merge-action-btn pw_remove-action-btn"
                onClick={() => removeMergeNow(removePayLoad)}
              >
                <i className="fa fa-unlink"></i>
                Remove Selected Exercises
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default MergeExerciseModal;
